import { SubdomainConfig } from '@/types/subdomain';
import React from 'react';
const SubdomainContext = React.createContext<SubdomainConfig | null>(null);
export const SubdomainContextProvider = SubdomainContext.Provider;
export default SubdomainContext;
